/*
  bekent: sortering virker ikke på desktop i Xtra 8.3.0.
  Xtras dropdown (BVSelect i plugin-selects.js) ændrer <select id="sort_by">,
  men sender ikke et change-event. page-collection.js lytter efter change,
  så sorteringen udføres aldrig. Denne fil sender eventet.
  Kan slettes, når Xtra har rettet fejlen.
*/
(function () {
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.bv_ul_inner .li');
    if (!item) return;

    var wrapper = item.closest('.bv_mainselect');
    if (!wrapper) return;

    var select = wrapper.previousElementSibling;
    if (!select || select.id !== 'sort_by') return;

    var forrige = select.dataset.bekentLast ||
      (select.querySelector('option[selected]') || select.options[0]).value;

    if (select.value === forrige) return;

    select.dataset.bekentLast = select.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();